import React, { MouseEvent } from "react";
import { styled } from "styled-components";
import Flex from "../../components/Box/Flex";
import { Text } from "../../components/Text";
import { MotionBox } from "../../components/Box";
import { ArrowBackIcon, CloseIcon } from "../../components/Svg";
import { IconButton } from "../../components/Button";
import { ModalProps } from "./types";

export const mobileFooterHeight = 73;

export const ModalHeader = styled(Flex) <{ background?: string; headerBorderColor?: string }>`
  align-items: center;
  background: #3A3447;
  border-bottom: 1px solid ${({ theme, headerBorderColor }) => headerBorderColor || theme.colors.cardBorder};
  display: flex;
  padding: 20px 24px 18px 32px;

  // ${({ theme }) => theme.mediaQueries.md} {
  //   background: transparent; //${({ background }) => background || "transparent"};
  // }
`;

export const ModalTitle = styled(Flex)`
  align-items: center;
  flex: 1;
`;

export const ModalBody = styled(Flex)`
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(90vh - ${mobileFooterHeight}px);
  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
    // max-height: 90vh;
  }
`;

const CloseButton = styled(IconButton)`
  // border: 2px solid ${({ theme }) => theme.colors.primary};
  // border-radius: 100%;
  width: 40px;
  height: 40px;
  margin-top: 0;
`;

export const ModalCloseButton: React.FC<React.PropsWithChildren<{ onDismiss: ModalProps["onDismiss"] }>> = ({
  onDismiss,
}) => {
  return (
    <CloseButton
      variant="text"
      scale="sm"
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onDismiss?.();
      }}
      aria-label="Close the dialog"
      mt={-2}
    >
      <CloseIcon color="#877A9F" />
    </CloseButton>
  );
};

export const ModalBackButton: React.FC<React.PropsWithChildren<{ onBack: ModalProps["onBack"] }>> = ({ onBack }) => {
  return (
    <IconButton variant="text" onClick={onBack} area-label="go back" mr="8px">
      <ArrowBackIcon color="text" />
    </IconButton>
  );
};

export const ModalContainer = styled(MotionBox)<{ $isTopRight?: boolean }>`
  overflow: hidden;
  background: #332D3E; // linear-gradient(180deg, #2a0d20 0%, #210d20 50%, #1a0e20 100%);
  box-shadow: 0px 10px 15px -3px #1018281A, 0px 4px 6px -4px #1018281A, 0px 25px 25px 0px #0000002B, 0px 55px 33px 0px #0000001A, 0px 98px 39px 0px #00000008, 0px 153px 43px 0px #00000000;
  // box-shadow: 0px 20px 36px -8px rgba(14, 14, 44, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.05);
  // border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  height: max-content;
  max-height: calc(var(--vh, 1vh) * 90);
  width: 100%; 
  max-width: 100%; 
  border-radius: 16px;
  position: fixed;
  z-index: auto;
  &:last-child {
    z-index: ${({ theme }) => theme.zIndices.modal};
  }

  ${({ $isTopRight, theme }) =>
    $isTopRight
      ? `
        top: 60px;
        right: 10px;
        max-width: 400px;
      `
      : `
        border-radius: 16px 16px 0 0;
        bottom: 0;

        ${theme.mediaQueries.sm} {
          bottom: unset;
          max-width: min(600px, 80%);
          border-radius: 16px;
          width: auto;
        }
      `
  }

  @media (max-width: ${({ theme }) => theme.breakpoints[0]}) {
    max-height: calc(var(--vh, 1vh) * 100);
  }
`;